import React, { useState, useEffect } from "react";
import { Printer, CreditCard, X, QrCode, CheckCircle2, Hash, IndianRupee } from "lucide-react";
import { db } from "../../firebase";
import { ref, set, get } from "firebase/database";

export default function ChallanStatus() {
  const [showPayment, setShowPayment] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentDone, setPaymentDone] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [paymentData, setPaymentData] = useState({
    userUpiId: "",
    paidAmount: "5000"
  });
  const [isPaid, setIsPaid] = useState(false);

  const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      if (currentUser._node && currentUser._key) {
        try {
          const userRef = ref(db, `${currentUser._node}/${currentUser._key}`);
          const snapshot = await get(userRef);
          if (snapshot.exists()) {
            const data = snapshot.val();
            // Check for Status payment specifically
            if (data.statusPaymentStatus === 'paid') {
              setIsPaid(true);
              const invoiceRef = ref(db, `${currentUser._node}/${currentUser._key}/payments/Registration status invoice`);
              const invoiceSnapshot = await get(invoiceRef);
              if (invoiceSnapshot.exists()) {
                setInvoiceData(invoiceSnapshot.val());
              }
            }
          }
        } catch (error) {
          console.error("Error fetching payment status:", error);
        }
      }
    };
    fetchPaymentStatus();
  }, [currentUser._node, currentUser._key]);

  // Determine user type and format data
  const isSociety = currentUser._node && currentUser._node.includes('Society');

  const userName = isSociety
    ? (currentUser.societyName || "संस्थेचे नाव")
    : `${currentUser.surname || ''} ${currentUser.firstName || ''} ${currentUser.middleName || ''} `.trim() || "वापरकर्ता";

  const mobile = isSociety
    ? (currentUser.chairmanWhatsapp || "9156602715")
    : (currentUser.whatsappNo || "9156602715");

  const address = isSociety
    ? `${currentUser.societyAddress || ''} ${currentUser.taluka ? `ताल-${currentUser.taluka}` : ''}`
    : `${currentUser.currentAddress || ''} ${currentUser.taluka ? `ताल-${currentUser.taluka}` : ''}`;

  const displayAddress = address.trim() ? `${address}, दिसत-सांगली` : "दुधगांव ताल-मिरज, दिसत-सांगली";

  const today = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).replace(/\//g, '-');

  const handlePrint = () => {
    window.print();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentData(prev => ({ ...prev, [name]: value }));
  };

  const handleCompletePayment = async () => {
    if (!paymentData.userUpiId) {
      alert("कृपया तुमचा यूपीआय आयडी भरा (Please fill your UPI ID)");
      return;
    }

    setLoading(true);
    try {
      const userKey = currentUser._key;
      const userNode = currentUser._node;

      const paymentRef = ref(db, `${userNode}/${userKey}/payments/Registration status invoice`);

      const receiptId = `ZP-STAT-${Math.floor(100000 + Math.random() * 900000)}`;
      const timestamp = new Date().toISOString();

      const paymentPayload = {
        userUpiId: paymentData.userUpiId,
        paidAmount: paymentData.paidAmount,
        userName,
        mobile,
        date: timestamp,
        receiptId: receiptId,
        status: 'completed',
        type: 'Registration Status Fee'
      };

      await set(paymentRef, paymentPayload);

      if (userNode && userKey) {
        const statusRef = ref(db, `${userNode}/${userKey}/statusPaymentStatus`);
        await set(statusRef, 'paid');
      }

      setPaymentDone(true);
      setIsPaid(true);
      setInvoiceData(paymentPayload);

      setTimeout(() => {
        setPaymentDone(false);
        setShowPayment(false);
        setShowInvoice(true);
        setPaymentData({ userUpiId: "", paidAmount: "5000" });
      }, 2000);

    } catch (error) {
      alert("पेमेंट सबमिट करताना त्रुटी आली: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const upiId = "sangramshinde7007@okhdfcbank";
  const amount = 5000;
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(`upi://pay?pa=${upiId}&pn=Zilla%20Parishad%20Sangli&am=${amount}&cu=INR&tn=Registration%20Status%20Fee`)}`;

  return (
    <div className="min-h-screen bg-white print:bg-white overflow-x-hidden">
      {/* Professional Header - Hidden on Print */}
      <div className="bg-white border-b border-gray-100 shadow-sm px-6 py-4 flex justify-between items-center print:hidden mb-6 sticky top-0 z-50">
        <div className="flex items-center gap-3">
          <div className="bg-blue-600 p-2 rounded-lg text-white">
            <CreditCard size={20} />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900 leading-none">चलन डाउनलोड आणि स्टेटस</h1>
            <p className="text-xs text-gray-500 mt-1">सांगली जिल्हा परिषद / रजिस्ट्रेशन स्टेटस</p>
          </div>
        </div>
        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-4 py-2 bg-gray-50 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors font-medium border border-gray-200"
        >
          <Printer size={18} />
          चलन प्रिंट करा
        </button>
      </div>

      <div className="max-w-[1200px] mx-auto p-4 md:p-8">
        {/* Main Content Card */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 md:p-12 print:border-none print:shadow-none print:p-0 overflow-hidden relative">

          {/* Watermark/Background Decoration */}
          <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-blue-50/20 rounded-full blur-3xl -z-10"></div>
          <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-96 h-96 bg-indigo-50/20 rounded-full blur-3xl -z-10"></div>

          {/* Challan Form Internal Area - Always Visible, Scrollable on mobile */}
          <div className="w-full overflow-x-auto border border-gray-100 rounded-xl print:border-none print:overflow-visible animate-in fade-in duration-700">
            <div className="border-[1.5px] border-gray-800 min-w-[800px] max-w-5xl mx-auto font-serif text-[13px] text-gray-900 leading-tight bg-white">
            {/* Header Row */}
            <div className="grid grid-cols-2 border-b border-gray-800">
              <div className="p-3 border-r border-gray-800 font-bold">Form No.2</div>
              <div className="p-3 font-bold text-right uppercase">CHALAN NO - ZP2023242527</div>
            </div>

            {/* Bank Info Section */}
            <div className="p-4 border-b border-gray-800">
              <p className="font-bold mb-1">Chalan of Cash paid into the Sangli Dist. Central Co-Op. Bank Ltd. at</p>
              <p className="font-bold">सांगली जिल्हा मध्यवर्ती सहकारी बँक लि. मध्ये भरलेल्या रोख रकमेचे चलन</p>
            </div>

            {/* Account Creditor Section */}
            <div className="p-4 border-b border-gray-800 font-bold">
              for creadit to the Zilla Parishad सांगली A/C - १०५०५३४००००७७३ with the Head Office
            </div>

            {/* Filling Instructions Headers */}
            <div className="grid grid-cols-[1fr_1fr] border-b border-gray-800 font-bold bg-gray-50/30">
              <div className="p-2 border-r border-gray-800">
                <p>To be filled in by the remitter</p>
                <p>रक्कम पाठविणाऱ्याने भरावयाचे</p>
              </div>
              <div className="p-2">
                <p>To be filled in by the Dep.Off</p>
                <p>खात्याच्या अंमलदाराने भरावयाचे</p>
              </div>
            </div>

            {/* Main Content Body */}
            <div className="grid grid-cols-[1fr_180px_1fr]">
              <div className="border-r border-gray-800 p-3 space-y-8">
                <div className="min-h-[100px]">
                  <p className="font-bold mb-1">By whom tendered (Name)</p>
                  <p className="text-gray-600 mb-6 font-sans">रक्कम कोणी आणून दिली त्याचे नांव</p>
                  <p className="font-bold">Name (or designation ) and address of the person on whose behalf money is paid</p>
                  <p className="text-gray-600 text-xs font-sans">ज्यांच्या वतीने रक्कम भरण्यात आली त्या मनुष्याचे नांव (किंवा हुद्दा ) व पत्ता</p>
                </div>
              </div>

              <div className="border-r border-gray-800 p-3 flex flex-col items-center justify-center text-center font-bold bg-blue-50/5 font-sans">
                <p className="text-[17px] uppercase mb-1 leading-tight">{userName}</p>
                <p className="text-[15px] mb-1 font-black">{mobile}</p>
                <p className="text-[13px] font-normal leading-snug">{displayAddress}</p>
              </div>

              <div className="p-3">
                <div className="space-y-4 font-sans">
                  <div className="space-y-1">
                    <p className="font-bold">Account Classification</p>
                    <p className="font-bold">Major Head - <span className="font-normal text-gray-700">जि.प.सेस महसुली जमा</span></p>
                    <p className="font-bold">Minor Head - <span className="font-normal text-gray-700">०५९५ पंचायत राज कार्यक्रम</span></p>
                    <p className="font-bold">Detailed Head - <span className="font-normal text-gray-700">कंत्राटदार नोंदणी आकार कंत्राटदार फॉर्म फी</span></p>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mt-6">
                    <div>
                      <p className="font-bold underline">Correct</p>
                      <p className="text-gray-600">बरोबर</p>
                    </div>
                    <div>
                      <p className="font-bold">Recived and grant receipts</p>
                      <p className="text-gray-600 italic">पैसे घेऊन पावत्या द्याव्यात.</p>
                    </div>
                  </div>

                  <div className="mt-6">
                    <p className="font-bold">Date दिनांक : {today}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Lower Middle Section */}
            <div className="grid grid-cols-[1fr_180px_1fr] border-t border-gray-800">
              <div className="p-3 border-r border-gray-800">
                <p className="font-bold italic">Full perticulars of the remittances and the authority (if any)</p>
                <p className="text-gray-600 font-sans italic text-xs mt-1">पाठवलेल्या रकमेचा व अधिकारपत्र (कोणतेही असल्यास ) त्याचा पूर्ण तपशील</p>
              </div>
              <div className="p-3 border-r border-gray-800 flex flex-col justify-between items-center text-center">
                <div>
                  <p className="font-bold">Amount</p>
                  <p className="text-gray-500 font-sans text-xs">रक्कम</p>
                </div>
              </div>
              <div className="p-3 font-bold border-gray-800 text-center font-sans space-y-1">
                <p className="text-[14px]">सहाय्यक लेखाधिकारी..</p>
                <p className="font-normal text-gray-600 text-[11px]">बांधकाम विभाग जि . प . सांगली</p>
                <p className="text-[10px] text-gray-500 font-normal leading-tight">पेशावा १ रणा करणाऱ्याबद्दल फर्गाविणाऱ्या अंमलदाराची सही व पुर्ण हुद्दा</p>
              </div>
            </div>

            {/* Amount Row */}
            <div className="grid grid-cols-[1fr_180px_1fr] border-t border-gray-800">
              <div className="p-3 border-r border-gray-800 font-bold font-sans">
                निविदा फॉर्म फी
              </div>
              <div className="p-3 border-r border-gray-800 font-bold text-center text-[15px]">
                Rs - 5000 /-
              </div>
              <div className="p-3">
                <p className="font-bold text-[11px] mb-2 leading-tight">To be used in only in the case of remittances to Bank through an officer of the zilla parishad</p>
                <p className="text-gray-600 text-[11px] font-sans">जिल्हा परिषदेचे अंमलदारामार्फत बँकेत रकमा पाठविण्यांत येतील त्या बाबतीतच फक्त उपयोगात आणावयाचे.</p>
              </div>
            </div>

            {/* Signature Area */}
            <div className="grid grid-cols-[1fr_180px_1fr] border-t border-gray-800 min-h-[90px]">
              <div className="p-3 border-r border-gray-800 flex items-end">
                <div className="flex w-full justify-between items-baseline px-4 font-bold">
                  <span className="text-gray-400 font-normal italic">Signature</span>
                  <p className="font-sans text-[11px]"><span className="mr-4">सही</span> <span>एकूण</span></p>
                  <span className="uppercase tracking-widest text-[10px]">Total</span>
                </div>
              </div>
              <div className="p-3 border-r border-gray-800 font-black text-center flex items-end justify-center text-[16px] pb-4 bg-gray-50/30">
                Rs - 5000 /-
              </div>
              <div className="p-3"></div>
            </div>

            {/* Words Row */}
            <div className="grid grid-cols-[1fr_1fr] border-t border-gray-800">
              <div className="p-4 border-r border-gray-800">
                <p className="font-bold">* In word Rupees - <span className="font-normal ml-4 font-sans italic">अक्षरी रुपये</span></p>
              </div>
              <div className="p-4 font-bold text-[15px] bg-blue-50/5">
                Rupees Five Thousand Only
              </div>
            </div>

            {/* Footer Row */}
            <div className="grid grid-cols-[1fr_1fr] border-t border-gray-800">
              <div className="p-6 border-r border-gray-800 font-bold h-32 flex flex-col justify-between relative italic">
                <p className="text-[10px] text-gray-400 uppercase not-italic">Cashier Section</p>
                <p className="italic">Cashier</p>
              </div>
              <div className="flex flex-col">
                <div className="grid grid-cols-2 border-b border-gray-800 h-16">
                  <div className="p-2 border-r border-gray-800 font-bold text-[10px] space-y-1">
                    <p>Recevied Payment Rupees</p>
                    <p className="mt-4 text-gray-400">Date: / / 2026</p>
                  </div>
                  <div className="p-2 font-bold text-[10px]">In words Rupees</div>
                </div>
                <div className="p-4 flex items-end h-16">
                  <p className="font-bold italic">Agent</p>
                </div>
              </div>
              </div>
            </div>
          </div>

          {/* Pay Online Call to Action - Always Visible if not paid, Invoice if paid */}
          <div className="mt-12 flex justify-center print:hidden border-t pt-12 border-gray-50">
            {isPaid ? (
              <div className="bg-green-50/50 border-2 border-green-200 rounded-[2.5rem] p-10 flex flex-col items-center gap-6 max-w-md w-full shadow-xl shadow-green-100/20 animate-in fade-in slide-in-from-bottom-4 duration-700">
                <div className="bg-green-100 text-green-600 w-24 h-24 rounded-full flex items-center justify-center shadow-lg border-4 border-white animate-pulse">
                  <CheckCircle2 size={48} />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-black text-green-800 mb-2">पेमेंट यशस्वी झाले आहे!</h3>
                  <p className="text-green-700/70 font-bold text-sm">तुमचे कंत्राटदार नोंदणी स्टेटस शुल्क प्राप्त झाले आहे.</p>
                </div>
                <button
                  onClick={() => setShowInvoice(true)}
                  className="w-full flex items-center justify-center gap-3 px-8 py-4 bg-green-600 hover:bg-green-700 text-white rounded-2xl font-black shadow-lg shadow-green-200 transition-all transform hover:-translate-y-1 active:scale-95 border-b-4 border-green-800"
                >
                  <Printer size={20} />
                  पावती डाउनलोड करा (Download Invoice)
                </button>
              </div>
            ) : (
              <div className="text-center group">
                <p className="text-gray-500 text-sm mb-6 font-medium italic animate-pulse">तुमचे पेमेंट पूर्ण करण्यासाठी खालील बटणावर क्लिक करा</p>
                <button
                  onClick={() => setShowPayment(true)}
                  className="flex items-center gap-4 px-12 py-5 bg-gradient-to-br from-blue-700 via-blue-800 to-indigo-900 text-white rounded-[1.25rem] hover:shadow-2xl hover:shadow-blue-200 transition-all transform hover:-translate-y-1 font-black text-xl shadow-xl border border-white/10"
                >
                  <CreditCard size={28} />
                  ऑनलाइन पेमेंट करा (Pay Online)
                </button>
              </div>
            )}
          </div>

        </div>
      </div>

      {/* Refined Payment Modal */}
      {showPayment && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm z-[2000] flex items-center justify-center p-3 sm:p-4 print:hidden">
          <div className="bg-white rounded-[2rem] sm:rounded-[3.5rem] w-full max-w-[550px] shadow-[0_40px_80px_-15px_rgba(0,0,0,0.5)] overflow-hidden animate-in fade-in zoom-in duration-500 border border-gray-100 flex flex-col relative max-h-[90vh] overflow-y-auto">

            {/* Header Section - Blue Gradient */}
            <div className="bg-gradient-to-b from-blue-700 to-blue-900 p-6 sm:p-10 flex flex-col items-center gap-4 relative">
              <button
                onClick={() => setShowPayment(false)}
                className="absolute right-8 top-8 bg-white/20 hover:bg-white/30 p-2 rounded-full transition-all text-white shadow-lg backdrop-blur-md"
                title="बंद करा"
              >
                <X size={20} />
              </button>

              <h3 className="text-3xl font-bold text-white tracking-wide">यूपीआय पेमेंट</h3>
              <div className="bg-[#2463EB] px-6 py-1 rounded-sm">
                <p className="text-white text-[11px] font-black uppercase tracking-[0.2em]">Registration Status Payment</p>
              </div>
            </div>

            {/* Body Section */}
            <div className="p-6 sm:p-10 flex flex-col items-center gap-6 sm:gap-8">
              {paymentDone ? (
                <div className="py-12 flex flex-col items-center gap-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
                  <div className="bg-green-50 text-green-500 w-24 h-24 rounded-full flex items-center justify-center shadow-xl shadow-green-100 border-4 border-white animate-bounce">
                    <CheckCircle2 size={48} />
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900">यशस्वी!</h4>
                  <p className="text-gray-500 font-medium">पडताळणी प्रक्रियेत आहे...</p>
                </div>
              ) : (
                <>
                  {/* QR Code */}
                  <div className="relative group">
                    <div className="p-8 bg-white rounded-[2.5rem] shadow-[0_15px_50px_-10px_rgba(0,0,0,0.1)] border border-gray-100/50 relative">
                      <div className="absolute inset-0 bg-blue-400/10 blur-[30px] rounded-full -z-10 group-hover:bg-blue-400/20 transition-all duration-500"></div>
                      <img src={qrUrl} alt="UPI QR Code" className="w-[220px] h-[220px] rounded-xl" />

                      {/* Floating Price Badge */}
                      <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-[#2D3383] text-white px-8 py-2 rounded-full font-black text-sm shadow-xl border-2 border-white min-w-[120px] text-center">
                        ₹5000.00
                      </div>
                    </div>
                  </div>

                  {/* Input Section */}
                  <div className="w-full flex flex-col items-center gap-4 mt-2">
                    <div className="bg-[#2463EB] px-6 py-1 rounded-sm">
                      <label className="text-white text-[11px] font-black uppercase tracking-[0.1em]">तुमचा यूपीआय आयडी (YOUR UPI ID)</label>
                    </div>
                    <div className="w-full bg-[#f8f9fa] rounded-[2rem] p-4 border border-gray-100 shadow-inner group">
                      <input
                        type="text"
                        name="userUpiId"
                        value={paymentData.userUpiId}
                        onChange={handleInputChange}
                        placeholder="उदा. name@upi"
                        className="w-full bg-transparent text-center text-xl font-bold text-gray-800 placeholder:text-gray-300 outline-none"
                      />
                    </div>
                  </div>

                  {/* Footer Action */}
                  <div className="w-full flex flex-col gap-4">
                    <button
                      onClick={handleCompletePayment}
                      disabled={loading}
                      className="w-full py-5 bg-gradient-to-r from-blue-700 to-indigo-900 text-white rounded-[2rem] font-black text-xl hover:shadow-[0_20px_40px_-5px_rgba(30,27,75,0.4)] transition-all flex items-center justify-center gap-3 disabled:opacity-50 transform active:scale-[0.98]"
                    >
                      {loading ? (
                        <div className="w-6 h-6 border-3 border-white/30 border-t-white rounded-full animate-spin"></div>
                      ) : (
                        <>पेमेंट पूर्ण करा</>
                      )}
                    </button>
                    <button
                      onClick={() => setShowPayment(false)}
                      className="text-gray-400 font-bold text-xs uppercase tracking-widest hover:text-gray-600 transition-colors"
                    >
                      Go Back
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Payment Invoice Modal */}
      {showInvoice && invoiceData && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-md z-[3000] flex items-center justify-center p-3 sm:p-4 overflow-y-auto print:p-0 print:bg-white print:backdrop-blur-none">
          <div className="bg-white rounded-[1.5rem] sm:rounded-[2.5rem] w-full max-w-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-500 flex flex-col print:shadow-none print:rounded-none">

            {/* Invoice Header */}
            <div className="bg-gradient-to-r from-blue-800 to-indigo-900 p-5 sm:p-8 text-white flex justify-between items-center print:from-white print:to-white print:text-black print:border-b-2 print:border-gray-800">
              <div className="flex items-center gap-4">
                <div className="bg-white/20 p-3 rounded-2xl backdrop-blur-md print:bg-gray-100 print:text-black">
                  <CreditCard size={32} />
                </div>
                <div>
                  <h2 className="text-2xl font-black uppercase tracking-tight">Payment Receipt</h2>
                  <p className="text-blue-100/70 text-xs font-bold print:text-gray-500">सांगली जिल्हा परिषद (Zilla Parishad Sangli)</p>
                </div>
              </div>
              <div className="text-right print:hidden">
                <button
                  onClick={() => setShowInvoice(false)}
                  className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-colors"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            <div className="p-5 sm:p-10 space-y-6 sm:space-y-8 bg-white print:bg-none">

              {/* Receipt Info Row */}
              <div className="flex justify-between items-start border-b border-gray-100 pb-8 print:border-gray-800">
                <div className="space-y-1">
                  <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Receipt Number</p>
                  <p className="text-xl font-bold text-gray-800 tracking-tight">{invoiceData.receiptId}</p>
                </div>
                <div className="text-right space-y-1">
                  <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Date & Time</p>
                  <p className="text-lg font-bold text-gray-800">
                    {new Date(invoiceData.date).toLocaleDateString('en-GB')} {new Date(invoiceData.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </p>
                </div>
              </div>

              {/* Payer Details */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-12 py-2">
                <div className="space-y-2">
                  <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Paid By (नाव)</p>
                  <p className="text-lg sm:text-xl font-bold text-blue-900 leading-tight">{invoiceData.userName}</p>
                  <div className="flex items-center gap-2 text-gray-500">
                    <Hash size={14} />
                    <span className="text-sm font-medium">{invoiceData.mobile}</span>
                  </div>
                </div>
                <div className="sm:text-right space-y-2">
                  <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Payment Details</p>
                  <p className="text-base sm:text-lg font-bold text-gray-800">UPI Online Payment</p>
                  <p className="text-xs font-mono text-blue-600 bg-blue-50 px-3 py-1 rounded-full inline-block">{invoiceData.userUpiId}</p>
                </div>
              </div>

              {/* Description Table - Scrollable */}
              <div className="w-full overflow-x-auto bg-gray-50/50 rounded-[1.5rem] sm:rounded-[2rem] border border-gray-100 print:border-gray-800">
                <table className="w-full text-left border-collapse min-w-[400px]">
                  <thead className="bg-gray-100/50 print:bg-gray-200">
                    <tr>
                      <th className="px-8 py-4 text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">Description</th>
                      <th className="px-8 py-4 text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] text-right">Amount</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 print:divide-gray-800">
                    <tr>
                      <td className="px-8 py-8">
                        <p className="font-bold text-gray-900 text-lg">कंत्राटदार नोंदणी स्टेटस फी</p>
                        <p className="text-xs text-gray-500 mt-1 font-medium italic">Status Verification Fee for ZP Sangli</p>
                      </td>
                      <td className="px-8 py-8 text-right">
                        <p className="text-2xl font-black text-gray-900">₹5000.00</p>
                      </td>
                    </tr>
                    <tr className="bg-blue-600 print:bg-gray-100">
                      <td className="px-8 py-5 text-right">
                        <p className="text-[11px] font-black text-blue-100 uppercase tracking-widest print:text-black">Total Paid (एकूण भरले)</p>
                      </td>
                      <td className="px-8 py-5 text-right">
                        <p className="text-2xl font-black text-white print:text-black">₹5000.00</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Status Stamp */}
              <div className="flex justify-between items-center pt-4">
                <div className="relative">
                  <div className="border-[3px] border-green-600 px-6 py-2 rounded-xl rotate-[-12deg] flex flex-col items-center shadow-lg shadow-green-100/50 print:shadow-none">
                    <span className="text-green-600 font-black text-2xl uppercase tracking-tighter">SUCCESSFUL</span>
                    <span className="text-green-600 text-[8px] font-bold uppercase tracking-widest">Zilla Parishad Sangli</span>
                  </div>
                </div>
                <div className="text-center space-y-4 print:mt-12">
                  <div className="h-[2px] w-48 bg-gray-200 mx-auto print:bg-gray-800"></div>
                  <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Authorized Signatory</p>
                </div>
              </div>

              {/* Footer Actions */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-6 print:hidden">
                <button
                  onClick={handlePrint}
                  className="w-full sm:flex-1 py-4 sm:py-5 bg-gradient-to-r from-blue-700 to-indigo-900 text-white rounded-2xl font-black text-base sm:text-lg hover:shadow-2xl hover:shadow-blue-200 transition-all flex items-center justify-center gap-3 transform active:scale-[0.98]"
                >
                  <Printer size={20} className="sm:w-6 sm:h-6" />
                  पावती प्रिंट करा (Print Receipt)
                </button>
                <button
                  onClick={() => setShowInvoice(false)}
                  className="px-8 py-5 border-2 border-gray-100 text-gray-500 rounded-2xl font-bold hover:bg-gray-50 transition-colors"
                >
                  बंद करा
                </button>
              </div>
            </div>

            {/* Note */}
            <div className="px-10 py-6 bg-gray-50 border-t border-gray-100 text-center print:bg-white print:border-gray-800">
              <p className="text-[10px] text-gray-400 font-bold uppercase tracking-[0.2em]">This is a computer generated receipt. No physical signature is required.</p>
            </div>
          </div>
        </div>
      )}

      <style dangerouslySetInnerHTML={{
        __html: `
        @media print {
          body { background-color: white !important; padding: 0 !important; margin: 0 !important; }
          footer, .print\\:hidden { display: none !important; }
          .max-w-[1200px] { max-width: 100% !important; width: 100% !important; padding: 0 !important; }
          .p-4, .md\\:p-8, .p-4, .md\\:p-12 { padding: 0 !important; }
          .rounded-2xl { border-radius: 0 !important; }
          .border, .shadow-sm { border: none !important; box-shadow: none !important; }
        }
      `}} />
    </div>
  );
}
